// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__rVtCs","logo":"Header_logo__2DVns","nav":"Header_nav__1iNTO","navList":"Header_navList__2J5aE"};